<div dashboard class="main-container">
  <div class="copilot-index-screen-container">
    <div class="chat-history-container">
      <app-chat-history></app-chat-history>
    </div>
    <router-outlet></router-outlet>
  </div>
  <div class="copilot-dynamic-background" [ngClass]="backgroundClass()">
    <img class="polaris-chat-background" [src]="'svg/polaris-chat-bg.svg' | assetVersion">
    <img class="polaris-star-background" [src]="'svg/polaris-star-bg.svg' | assetVersion">
  </div>
</div>

